// eslint-disable-next-line @typescript-eslint/ban-types
export function toPlainObject<T extends object>(object: T): T {
	return JSON.parse(JSON.stringify(object));
}
